module.exports = __webpack_public_path__ + "img/icon-view-only.787d0a6b.svg";